import { Box, CircularProgress, Container } from '@mui/material';
import Footer from "../../global/components/Footer";
import { useState, useEffect } from 'react';
import { useDuesSponsoredOrgContext } from '../../global/hooks/useDuesSponsoredOrgContext';
import { useIlpContext } from '../hooks/useIlpContext';
import { useAdvisorContext } from '../hooks/useAdvisorContext';
import { IReviewerView } from "../types/interfaces/IReviewerView";
import { IIndividualLearningPlan } from '../types/interfaces/IIndividualLearningPlan';
import AssessmentView from './AssessmentView';
import ProgramBlock from './ProgramBlock';
import AdvisorPlanList from './AdvisorPlanList';

//This component is responsible for rendering the ilp content.
export default function AdvisorLandingView() {
    const { selectedOrganization } = useDuesSponsoredOrgContext();
    const { loadingIlpCtx, setExpandAll, setAreChildrenLoading } = useIlpContext();
    const { reviewerViewArray, individualLearningPlan, setIndividualLearningPlan, loadingAdvisorCtx } = useAdvisorContext();
    const [topLoadingAdvisor, setTopLoadingAdvisor] = useState(loadingIlpCtx || loadingAdvisorCtx);
    const RESIDENT_ROLE = process.env.REACT_APP_NFROLE_RESIDENT;
    const reviewerViews: IReviewerView[] | any = [];
    if (reviewerViewArray) {
        reviewerViewArray.forEach((reviewerView: IReviewerView) => {
            reviewerViews.push(reviewerView);
        });
    }

    useEffect(() => {
        if (!loadingIlpCtx && !loadingAdvisorCtx) {
            setTopLoadingAdvisor(false);
            setAreChildrenLoading(false)
        }
    }, [loadingIlpCtx, loadingAdvisorCtx]);

    //Function to handle an ilp selection. Implemented in AdvisorPlanList.
    const handleSelect = (selectedIlp: IIndividualLearningPlan | null) => {
        setIndividualLearningPlan(selectedIlp);
    };

    //Function to handle canceling. Implemented in AssessmentView.
    const handleCancel = () => {
        setIndividualLearningPlan(null);
        setExpandAll(false);
    };

    //Function to handle an ilp approving.  Implemented in AssessmentView for advisors only.
    const handleApprove = (savedIlp: IIndividualLearningPlan | null) => {
        setIndividualLearningPlan(null);
    };

    //Function to handle an ilp updating for a saved plan comment.
	const handleCommentSave = (updateIlp: IIndividualLearningPlan | null) => {
		setIndividualLearningPlan(updateIlp);
    };

    //Function to handleprint view.
    const handlePrint = (printIlp: IIndividualLearningPlan | null) => {
        if (printIlp?.LearnerInfo.Role === RESIDENT_ROLE) {
        setExpandAll(true);
        }
    };

    return (
        <Container>
            {topLoadingAdvisor && <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: 2 }}>
                 <CircularProgress />
            </Box>}
            {individualLearningPlan ? (
                <AssessmentView plan={individualLearningPlan} onSave={handleApprove} onCancel={handleCancel} onCommentSave={handleCommentSave} onPrint={handlePrint} />) : (
                <>
                    {selectedOrganization && <ProgramBlock />}
                    {!topLoadingAdvisor && (reviewerViews?.length > 0 ?
                        (<AdvisorPlanList onSelect={handleSelect} />) : (
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: 2, paddingBottom: 4 }}>
                                {process.env.REACT_APP_ILP_NO_SUBMITTED_PLANS_FOR_ADVISORS}
                            </Box>)
                    )}
                </>
            )}
            </Container>
    );
}